import { takeLeading } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { get } from 'lodash';
import userToken from 'containers/services/security/access-token-storage';
import { REQUEST_MANAGER_PENDING_CLAIMS } from 'containers/ManagerPendingClaims/constants';
import * as ManagerPendingClaimsActions from 'containers/ManagerPendingClaims/actions';

export function* requestManagerPendingClaims(action: any) {
  const { status, page, pageSize } = action;
  const token = get(userToken.get(), 'token');
  const path = `/corporeal/common/claims?status=${status}&page=${page}&pageSize=${pageSize}`;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
  yield callApi(
    path,
    {},
    options,
    [],
    ManagerPendingClaimsActions.setManagerPendingClaims(false),
  );
}

export function* requestManagerPendingClaimsSaga() {
  yield takeLeading(
    REQUEST_MANAGER_PENDING_CLAIMS,
    requestManagerPendingClaims,
  );
}

export default [requestManagerPendingClaimsSaga];
